import type { KeyboardEvent } from 'react';

// ----------------------------------------------------------------------

/** The keys that activate a button: Enter and Space. */
export const isActivationKey = (event: Pick<KeyboardEvent, 'key'>) =>
  event.key === 'Enter' || event.key === ' ';

/**
 * `onKeyDown` for an element that acts like a button but can't be one (a `<tr>`, a
 * `role="radio"` card). Enter/Space call `onActivate` only while the element itself has focus,
 * so keys pressed on a nested button, checkbox or input keep their own meaning.
 *
 * Reach for a real `<button>` / `ButtonBase` / `Link` first — they get this for free.
 */
export const onActivationKey =
  <T extends Element>(onActivate: () => void) =>
  (event: KeyboardEvent<T>) => {
    if (event.target !== event.currentTarget || !isActivationKey(event)) return;
    event.preventDefault();
    onActivate();
  };
